import React from 'react'
import { IIconProps } from '../types/types'

const InstaDots: React.FC<IIconProps> = (props) => {
  return (
    <>
      <svg
        className={props.className}
        xmlns='http://www.w3.org/2000/svg'
        height={props.width ? props.width : '24px'}
        width={props.width ? props.width : '24px'}
        fill={props.color ? props.color : '#262626'}
        viewBox='0 0 24 24'
      >
        <circle cx='12' cy='12' r='1.5' />
        <circle cx='6.5' cy='12' r='1.5' />
        <circle cx='17.5' cy='12' r='1.5' />
      </svg>
    </>
  )
}

export default InstaDots
